import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';
import { t } from '../../../auto/js/services';
import { loadingIcon } from '../../../auto/js/loadingIcon';

const statusColor = {
  "PENDING": 'warning',
  "SIGNED": 'success',
  "REJECTED": 'error',
};

const RequestCard = ({ request, action }) => (
  <Card variant="outlined" sx={{
    width: '100%',
    borderRadius: 2, // equivalent to 16px
    }} >
    <CardContent>
      <Typography variant="caption" color="text.secondary">
        #REQ-{request.id}
      </Typography>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h6">
            {request.title}
        </Typography>
        <Chip
            clickable
            onClick={() => action(request)}
            label={request.status}
            color={statusColor[request.status]}
            size="small"
            sx={{
                height: 36, // typical Button height
                fontSize: '0.875rem', // similar to Button text
                px: 2, // horizontal padding to match button feel
                borderRadius: '6px', // optional: to match button roundness
            }}
        />
        </Box>
        <>
          <Stack direction="row" spacing={2} mt={1}>
            <Stack direction="row" spacing={0.5}>
              <DescriptionIcon fontSize="small" />
              <Typography variant="body2">{request.documents} documents</Typography>
            </Stack>
            <Stack direction="row" spacing={0.5}>
              <PeopleIcon fontSize="small" />
              <Typography variant="body2">
                {request.people}
                {request.signed !== undefined && ` (${request.signed} signed)`}
                {request.rejected !== undefined && ` (${request.rejected} rejected)`}
              </Typography>
            </Stack>
          </Stack>
          
        </>
    </CardContent>
  </Card>
);

export default function MySignature(props) {
  const [myRequests, setMyRequests] = useState(undefined);

  if (!myRequests){
    props.loadData().then((data) => {
      setMyRequests(data)
    })
    return loadingIcon;
  }

  return (
    <Container maxWidth={false} >
      <Button variant="contained" onClick={() => props.new()} startIcon={<AddIcon />} sx={{ mb: 3 }}>
        {t`New Request`}
      </Button>

      <Box
        sx={{
          display: 'flex',
          flexDirection: ['column', 'column', 'row'],
          gap: 4,
        }}
      >
        {/* My Signature Requests */}
        <Box sx={{ flex: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6" gutterBottom>
                {t`My Signature Requests`}
            </Typography>
            <Button className="link-button" onClick={() => props.seeAll()}>
                {t`See all`}
            </Button>
          </Box>
          <Stack spacing={2}>
            {myRequests.map((req) => (
              <RequestCard key={req.id} request={req} action={props.action}/>
            ))}
          </Stack>
        </Box>
      </Box>
    </Container>
  );
}
